import React from 'react'
import { checkTranslation, chooseWallpaper, conditionalWidth, imageAddress, translate } from "../../utils/useful";
import Responsive from '../../components/Responsive';
import Modal from '../../components/Modal';
import FormViewer from '../../components/FormViewer';
import { Doughnut, Bar, Line, Pie } from 'react-chartjs-2';
import TaskSingleView from './TaskSingleView';
import LoaderButton from '../../components/LoaderButton';
import Collapsible from 'react-collapsible';
import SettingsViewer from '../../components/SettingsViewer';
import SelectAppletInput from '../../components/inputs/SelectAppletInput';
import EditorInput from '../../components/inputs/EditorInput';
import TextAreaInput from '../../components/inputs/TextAreaInput';
// import ObserverInput from '../../components/inputs/ObserverInput';

class AddTaskModal extends React.Component {
    state = {
        description: '',
        headers: [
            // { key: 'assignee', type: 'GlobalUserInput', information: { label: '{{lang}}Assignee', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}select', required: false, } },
            // { key: 'timeline', type: 'TextInput', information: { label: '{{lang}}timeline', placeholder: '{{lang}}timeline', required: false } },
            { key: 'timeline', type: 'CalendarInput', information: { label: '{{lang}}desk.timeline', placeholder: '', required: false } },
            { key: 'priority', type: 'StatusSelectInput', inPlaceEdit: true, information: { label: '{{lang}}desk.priority', placeholder: '{{lang}}desk.priority', items: [{ label: '{{lang}}desk.High', key: 'high', color: '#CA5C72', bgColor: '#FEE9EE' }, { label: '{{lang}}desk.Medium', key: 'medium', color: '#CAA55C', bgColor: '#FEF2E9' }, { label: '{{lang}}desk.Low', key: 'low', color: '#00c875', bgColor: '#00c87520' }], required: false } },
        ],

        header: [
            { key: 'assignees', type: 'GlobalUserMultiInput', information: { label: '{{lang}}desk.Assignee', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.Select', required: false, } },
            // { key: 'assignee', type: 'MultiSelectInput', information: { label: '{{lang}}Assignee', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}select', required: false, } },
            { key: 'observer', type: 'GlobalUserMultiInput', information: { label: '{{lang}}desk.Observer', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.Select', required: false, } },

        ],
        addList: [
            { label: '{{lang}}desk.File', icon: '/assets/icons/useful/clip.svg', },
            { label: '{{lang}}desk.Drive', icon: '/assets/icons/useful/save.png', },
            { label: '{{lang}}desk.Editor', icon: '/assets/icons/useful/text.svg', },
            { label: '{{lang}}desk.Voice', icon: '/assets/icons/useful/microphone.svg', },

        ]


    }



    componentDidMount() {
        window.addEventListener("keydown", this.keyPress)

    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.keyPress)
    }



    keyPress = (e) => {
        if (e?.keyCode == 13) {
            this.postTask()
        }
    }



    postTask = (newAfter) => {
        if (!this.state.isLoadingOther && !this.state.isLoading) {
            let data = this.state.data
            let formData = this.form1.getForm()
            let timeline = this.form.getForm();
            timeline = timeline.timeline
            console.log('timeline', timeline)
            let description = this.state.description
            if (formData && data) {
                data = { ...data, ...formData, description, timeline, applet: this.props.currentApplet }
                // data.assignee = [data.assignee]
                console.log('data is ', data);
            }
            if (data?.title) {
                if (newAfter) {
                    this.setState({ isLoadingOther: true })
                } else {
                    this.setState({ isLoading: true })
                }
                this.props.postTask(data, (success, err) => {
                    this.setState({ isLoadingOther: false, isLoading: false })

                    if (success) {
                        this.setState({ data: {} })
                        if (newAfter) {

                        } else {
                            this.modal.hideModal()
                        }
                    }
                })
            }

        }
    }



    setData = (data, cb) => {
        let newData = this.state.data
        if (!newData) {
            newData = {}
        }
        for (const [key, value] of Object.entries(data)) {
            newData[key] = value
        }
        this.setState({ data: newData }, () => {
            if (cb) { cb() }
        })
    }



    changePage = (item) => {
        this.setState({ currentPage: item.key })
    }

    changeValue = (key, value) => {
        console.log('key', key, 'value', value)
        this.setState({ [key]: value })
    }



    render() {
        return (


            <Modal ref={el => this.modal = el} maxWidth={500}>
                <div className="modal-body py-4 px-4 bg-white " style={{ borderRadius: 8 }}>
                    <div className='px-3'>

                        <div className='flexc mb-1'>
                            <img height={"24px"} src={'/assets/icons/applets/general/text.png'} />
                            <p className='text-semibold mx-2'>{translate('desk.Add New Task')}</p>
                        </div>


                        {/* <div className='flexc mt-1'>
                            <img className='task-check-img' src={imageAddress(this.state.current?.user?.image, 'profile')} height={14} width={14} style={{ borderRadius: 20 }} />
                            <p className='task-applet-name text-smaller color-gray-2  cursor-pointer mx-1 text-semibold'>Elitive - Tasks Applet</p>
                        </div> */}



                        <div className='flexc position-relative'>
                            <input onChange={e => this.setData({ title: e.target.value })} autoFocus={true} className='w-100 mt-2' style={{ border: 'none', borderBottom: '1px solid rgba(229,231,233,0.5)', backgroundColor: '', borderRadius: 0, fontSize: 18, padding: '6px 0px' }} placeholder={translate("desk.What to do")} />
                            {/* <div className='position-absolute right-0'style={{top:20}}>
                                <img className='' src={'/assets/icons/useful/microphone.svg'} height={15} />
                            </div> */}
                        </div>


                        {/* <div className='flexc mt-2 pb-2' style={{ borderBottom: '1px solid rgba(229,231,233,0.5)' }}>
                            <SelectAppletInput changeValue={this.changeValue} header={{ key: 'applet', information: { label: '{{lang}}Assignee', address: 'getMyApplets', filter: {}, fields: { title: 'applet.name', description: 'appletHub.username', value: '_id', image: 'appletHub.image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select Applet', required: false, } }} />
                        </div> */}
                        {/* <FormViewer header={{ key: 'applet', information: { label: '{{lang}}Assignee', address: 'getMyApplets', filter: {}, fields: { title: 'applet.name', description: 'appletHub.username', value: '_id', image: 'appletHub.image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Select Applet', required: false, } }} initData={this.props.data} inputClass={'modern-input'} /> */}

                        {/* <div className='flexc mt-2 pb-2' style={{ borderBottom: '1px solid rgba(229,231,233,0.5)' }}>
                            <ObserverInput changeValue={this.changeValue} header={{ key: 'applet', information: { label: '{{lang}}Assignee', address: 'getMyApplets', filter: {}, fields: { title: 'applet.name', description: 'appletHub.username', value: '_id', image: 'appletHub.image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Observer', required: false, } }} />
                        </div> */}
                        <div className='flexc mt-2 pb-2' >
                            {/* <SettingsViewer ref={el => this.form = el} saveSetting={this.saveSetting} headers={this.state.header} initData={this.props.data} errors={this.state.errors} formClass={'settings-desk'} inputClass={'modern-input'} hideEditButton={true} singleSide={true} labelWidth={80} /> */}
                            <FormViewer ref={el => this.form1 = el} headers={this.state.header} initData={this.props.data} inputClass={'modern-input'} />
                        </div>
                        <div className='flexc mt-2 pb-2' >
                            {/* <EditorInput changeValue={this.changeValue} header={{ key: 'applet', information: { label: '{{lang}}Assignee', address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Description', required: false, } }} /> */}
                            <TextAreaInput data={this.state.description} changeValue={this.changeValue} header={{ key: 'description', information: { label: '{{lang}}Description', placeholder: '{{lang}}Description', required: false, } }} />

                        </div>



                        <div className='flexc mt-2 pb-2' style={{ borderBottom: '1px solid rgba(229,231,233,0.5)' }}>
                            <img className='task-check-img' src={imageAddress(this.state.current?.user?.image, 'profile')} height={28} width={28} style={{ borderRadius: 20 }} />
                            <div className='mx-2 flexc'>
                                <p className='task-applet-name text-smaller cursor-pointer  text-semibold' style={{ color: '#888' }}>Elitive</p>
                                <p className='task-applet-name text-smaller cursor-pointer mx-1  text-semibold' style={{ color: '#888' }}>{translate('desk. Tasks Applet')}</p>
                            </div>
                        </div>




                        <div className='flexc mt-3'>
                            {this.state.addList.map((prop, index) => {
                                return (
                                    <button className='p-0 flexcc flex-column mrd-5' style={{ opacity: 0.5 }}>
                                        <img className='' src={prop.icon} height={15} />
                                        <p className='text-smaller mt-1 '>{checkTranslation(prop.label)}</p>
                                    </button>
                                )
                            })}
                        </div>

                        <Collapsible open={this.state.showMore}>
                            <div className='pt-3'>
                                {/* <SettingsViewer ref={el => this.form = el} saveSetting={this.saveSetting} headers={this.state.headers} initData={this.props.data} errors={this.state.errors} formClass={'settings-desk'} inputClass={'modern-input'} hideEditButton={true} singleSide={true} labelWidth={80} /> */}
                                <FormViewer ref={el => this.form = el} headers={this.state.headers} initData={this.props.data} inputClass={'modern-input'}
                                    startDate={this.props.startDate} endDate={this.props.endDate} />
                            </div>
                        </Collapsible>


                        <div className='mt-3 mb-3'>
                            <button className='p-0 flexc' onClick={() => this.setState({ showMore: !this.state.showMore })}>
                                <p className='text-small ' style={{ color: '#777' }}>{translate(this.state.showMore ? translate("desk.Show less info") : translate("desk.Add more info"))}</p>
                                <img height={"18px"} style={{ opacity: 0.4 }} className='rtl-button' src={'/assets/icons/useful/angle-right.svg'} />
                            </button>
                        </div>

                        <div className='flexc mt-2 justify-content-end'>
                            {/* <div className=' flexc'>
                                    <LoaderButton
                                        onClick={() => this.postCode()}
                                        isLoading={this.state.isLoading}
                                        text={translate("Add And Other")}
                                        // disabled={!this.state.canContinue}
                                        background='linear-gradient(to right, #789, #578)'
                                        icon={'/assets/icons/useful/angle-right.svg'}
                                    />

                                </div> */}

                            {/* <button className='p-0' onClick={() => this.postTask(true)}>
                                <p className='color-gray-2 text-small mx-2'>{translate("Submit And Add Other")}</p>
                            </button> */}

                            <LoaderButton
                                onClick={() => this.postTask(true)}
                                isLoading={this.state.isLoadingOther}
                                text={translate("desk.Submit And Add Another")}
                                // disabled={!this.state.canContinue}
                                background='transparent'
                                color={"#888"}
                                justifyContent={'flex-end'}
                                language={this.props.language}
                            // icon={'/assets/icons/useful/plus.svg'}
                            />



                            <div className=' flexc mld-2'>
                                <LoaderButton
                                    onClick={() => this.postTask()}
                                    isLoading={this.state.isLoading}
                                    text={translate("desk.Submit")}
                                    // disabled={!this.state.canContinue}
                                    background='linear-gradient(to right, #7064FE, #6473FE)'
                                    icon={'/assets/icons/useful/plus.svg'}
                                />

                            </div>

                        </div>

                    </div>

                    {/* <div className='mt-3'>
                            <FormViewer ref={el => this.form = el} headers={this.state.headers} initData={this.props.initData} errors={this.state.errors} formClass="modern" inputClass={'modern-input'} />
                        </div> */}

                </div>
            </Modal>


        )
    }
}

export default AddTaskModal;